import { render } from "./notice.vue?vue&type=template&id=053e1a8c&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"

import "./notice.vue?vue&type=style&index=0&id=053e1a8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-053e1a8c"

export default script